export interface PlaybookTemplate {
  id: string;
  name: string;
  description: string;
  category: string;
  prompt: string;
  defaultAllowedTools: string[];
  defaultTriggerEntityTypes?: string[];
}

import { enrichContactsTemplate } from './enrichContacts';

const TEMPLATE_REGISTRY: Record<string, PlaybookTemplate> = {
  [enrichContactsTemplate.id]: enrichContactsTemplate,
};

export const getTemplate = (id: string): PlaybookTemplate | undefined => {
  return TEMPLATE_REGISTRY[id];
};

export const getAllTemplates = (): PlaybookTemplate[] => {
  return Object.values(TEMPLATE_REGISTRY);
};

export { enrichContactsTemplate };
